module.exports = __webpack_public_path__ + "img/member_print_description.0ad9c564.jpg";